import { render, staticRenderFns } from "./OdontogramaDetalle.vue?vue&type=template&id=c6ef072a&scoped=true"
import script from "./OdontogramaDetalle.vue?vue&type=script&lang=js"
export * from "./OdontogramaDetalle.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaDetalle.vue?vue&type=style&index=0&id=c6ef072a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ef072a",
  null
  
)

export default component.exports